import $ from 'jquery';
import breakpoints from './breakpoints';

const $window = $(window);
const $document = $(document);
const $body = $('body');
const $header = $('#header');
const $quickLinks = $('.quick-links');

const $paragraph = $('.paragraph--type--timeline-information');
const $sidebar = $paragraph.find('.sidebar');
const $content = $paragraph.find('.content');
const $titlesList = $paragraph.find('.titles-list');
const $titles = $paragraph.find('.title');
const $panels = $paragraph.find('.panel');
const $switches = $paragraph.find('.panel-switch');
const $covers = $paragraph.find('.title-cover');

const spacer = 30;
let isStuck = false;

function showTitlesList() {
  const $cover = $(this);
  const $title = $cover.parent();
  const top = $title.position().top + $title.height();

  $cover
    .addClass('active');

  $titlesList
    .addClass('show')
    .css({ top });
}

function hideTitlesList() {
  $titlesList
    .removeClass('show')
    .removeAttr('style');

  $covers
    .removeClass('active');
}

function setActiveTitle(key) {
  $titles
    .removeClass('active')
    .filter((i) => $titles.eq(i).data('timeline') == key)
      .addClass('active');
}

function setActivePanel(id) {
  $content
    .height($content.height());

  $panels
    .removeClass('active')
    .filter(id)
      .addClass('active')

  $content
    .removeAttr('style');
}

function scrollToPanel() {
  if (isStuck) {
    $window.scrollTop($content.offset().top - getOffset());
  }
}

function switchPanel(event) {
  event.preventDefault();

  const $switcher = $(this);
  const id = $switcher.attr('href');
  const key = id.replace('#timeline-', '');

  hideTitlesList();
  setActiveTitle(key);
  setActivePanel(id);
  scrollToPanel();
  recalcStickyKit();
}

function isSticky() {
  return breakpoints.min.bg.matches;
}

function initStickyKit() {
  const offset_top = getOffset();

  $sidebar
    .off('sticky_kit:stick sticky_kit:unstick')
    .trigger('sticky_kit:detach')
    .stick_in_parent({ offset_top })
    .on('sticky_kit:stick', () => { isStuck = true })
    .on('sticky_kit:unstick', () => { isStuck = false });
}

function destroyStickyKit() {
  $sidebar
    .off('sticky_kit:stick sticky_kit:unstick')
    .trigger('sticky_kit:detach');

  isStuck = false;
}

function getOffset() {
  return Drupal.displace.calculateOffset('top') + $header.height() + ($quickLinks.height() || 0) + spacer;
}

function updateStickyKit() {
  if (isStuck) {
    initStickyKit();
  }
}

function recalcStickyKit() {
  $sidebar
    .trigger('sticky_kit:recalc');
}

function testStickyKit() {
  if (isSticky()) {
    initStickyKit();

    $document.on('drupalViewportOffsetChange', updateStickyKit);
  } else {
    destroyStickyKit();

    $document.off('drupalViewportOffsetChange', updateStickyKit);
  }
}

export default () => {
  testStickyKit();
  breakpoints.min.bg.addListener(testStickyKit);

  $covers.click(showTitlesList);
  $switches.click(switchPanel);

  setTimeout(() => {
    if (isSticky() && !isStuck) {
      initStickyKit();
    }
  }, 150);
}
